var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideo3(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_368_4032)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6621 8.66197L14.1426 10.9823C14.1928 11.0157 14.2511 11.0348 14.3113 11.0377C14.3715 11.0406 14.4313 11.0271 14.4845 10.9987C14.5376 10.9702 14.582 10.9279 14.613 10.8762C14.644 10.8245 14.6604 10.7654 14.6604 10.7051V5.24344C14.6604 5.18482 14.645 5.12723 14.6156 5.07648C14.5862 5.02574 14.544 4.98364 14.4932 4.95444C14.4423 4.92523 14.3847 4.90996 14.3261 4.91016C14.2674 4.91036 14.2099 4.92602 14.1593 4.95557L10.6621 6.99602",
    stroke: "white",
    strokeWidth: 1.33276,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.32931 4H2.66552C1.92946 4 1.33276 4.5967 1.33276 5.33276V10.6638C1.33276 11.3999 1.92946 11.9965 2.66552 11.9965H9.32931C10.0654 11.9965 10.6621 11.3999 10.6621 10.6638V5.33276C10.6621 4.5967 10.0654 4 9.32931 4Z",
    stroke: "white",
    strokeWidth: 1.33276,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_368_4032"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9931,
    height: 15.9931,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo3);
export default __webpack_public_path__ + "static/media/video3.85b720514cc4d9de612c081684f29359.svg";
export { ForwardRef as ReactComponent };